<template>
  <card
    v-if="card.visible"
    :id="card.id"
    :key="card.id"
    :title="card.title"
    :title-action="card.titleAction"
    :capitalize-subtitle="card.capitalizeSubtitle"
    :transparent-card="card.transparentCard"
    :buttons="card.buttons"
    :class="{ 'card-disabled': card.disabled }"
  >
    <component
      :is="card.component.name"
      v-if="card.component"
      :key="card.component.key"
      :content="card.component.content"
    />
    <infotip
      v-if="card.disabled"
      :id="card.id + '-disabled'"
      :key="card.id + '-infotip-disabled'"
      :text="card.disabledMessage || 'A funcionalidade está temporariamente em manutenção.'"
      :auto-open-on-first-days="false"
      :never-open-again-after-dismissed="false"
      :close-on-mouse-leave="true"
    />
    <redirect-external-links ref="redirector" />
  </card>
</template>

<script>
import Card from '../Card'
import Infotip from '@/components/common/infotip/Infotip'
import QuickLinks from '../Widgets/QuickLinks'
import { mapActions, mapGetters } from 'vuex'
import { DASHBOARD_FAST_LINKS, eventBus } from '@/api/eventbus'
import RedirectExternalLinks from '@/components/common/RedirectExternalLinks'

export default {
  name: 'CardQuickLinks',
  components: {
    card: Card,
    infotip: Infotip,
    'quick-links': QuickLinks,
    'redirect-external-links': RedirectExternalLinks
  },
  computed: {
    ...mapGetters(['toggle', 'profile']),
    card() {
      return {
        id: 'quick-links',
        visible: true,
        disabled: false,
        title: 'Acesso rápido',
        coordinateId: '9',
        transparentCard: true,
        component: {
          name: 'quick-links',
          key: 4,
          content: {
            items: [
              {
                id: 'exam-list',
                visible: this.toggle.examListLink,
                icon: 'link',
                text: 'GUIA DE EXAMES',
                action: 'Lista de Exames',
                sizeSmall: true,
                toggle: 'examListLink'
              },
              {
                id: 'invoice',
                visible: this.toggle.billetLink && !this.toggle.covax,
                icon: 'link',
                text: 'FINANCEIRO',
                action: 'faturamento',
                sizeSmall: true,
                toggle: 'billetLink'
              },
              {
                id: 'documents',
                visible: this.toggle.documentsLink && !this.toggle.covax,
                icon: 'link',
                text: 'DOCUMENTOS',
                action: 'Documentos',
                sizeSmall: true,
                toggle: 'documentsLink'
              },
              {
                id: 'orderMaintenance',
                visible: !this.toggle.covax && this.toggle.exam_exclusion && this.toggle.exam_inclusion,
                icon: 'link',
                text: 'Inclusão/Exclusão de exames',
                action: 'Editar Amostras',
                sizeSmall: true,
                toggle: 'pendenciesManagement'
              },
              {
                id: 'reportGenerator',
                visible: this.toggle.reportGenerator,
                icon: 'link',
                text: 'Gerar relatórios',
                action: 'gerarRelatorio',
                sizeSmall: true,
                toggle: 'reportGenerator'
              }
            ]
          }
        }
      }
    }
  },
  created() {
    let self = this
    eventBus.$on(DASHBOARD_FAST_LINKS, function (param) {
      self.callAction(param)
    })
  },
  methods: {
    ...mapActions(['setOrderMaintenanceModalVisible']),
    callAction(action) {
      switch (action) {
        case 'Documentos':
          this.$router.push('/availableDocuments/search')
          break
        case 'Editar Amostras':
          this.setOrderMaintenanceModalVisible(true)
          break
        case 'Lista de Exames':
          let routeData = this.$router.resolve({ name: 'Exames' })
          window.open(routeData.href, '_blank')
          break
        case 'faturamento':
          this.$router.push('/faturamento')
          break
        case 'gerarRelatorio':
          this.$router.push('/gerar-relatorios')
          break
      }
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Dashboard Novo',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    }
  }
}
</script>
